export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-ja-JP.467c8a81.xlsx";